import React, {Component} from 'react';
import {Button, DatePicker, Select, message, Modal, Pagination} from 'antd';
import {Redirect} from 'react-router';
import './personalDetails.less';
import Vip from '../../../components/frontEnd/vip/vip';
import RechargeDetail from '../../../components/frontEnd/rechargeDetail/rechargeDetail';
import utils from '../../../utils/common';

const {Option} = Select;
const {RangePicker} = DatePicker;
const dateFormat = 'YYYY/MM/DD';

function GetStatus(props) {
  let label = <span>{}</span>;
  if (props.type === 'status') {
    switch (props.status) {
      case '1':
        label = <span>待审核</span>;
        break;
      case '2':
        label = <span style={{color: '#009933'}}>审核通过</span>;
        break;
      case '3':
        label = <span style={{color: '#fc3339'}}>审核不通过</span>;
        break;
      default: label;
    }
  } else if (props.type === 'invoiceType') {
    switch (props.status) {
      case '1':
        label = <span>增值税普票-纸制</span>;
        break;
      case '2':
        label = <span>增值税普票-电子</span>;
        break;
      case '3':
        label = <span>增值税专票</span>;
        break;
      default: label;
    }
  }
  return label;
}

class SearchDetail extends Component {
  state = {
    level: 0, // 代理商等级
    fullName: null, // 姓名
    firstStatus: null, // 初始状态
    secondStatus: null, // 复审状态
    createDate: null, // 创建日期
    rechargeType: null, // 充值方式
    invoiceType: null, // 是否开发票
    showDetail: false, // 显示支付详情
    rechargeDetail: {}, // 充值详情
    payInfo: [{}, {}], // 返佣账户信息
    payMod: ['返佣账户', '充值账户'],
    recordList: [], // 充值记录列表
    currentPage: 1, // 当前列表
    total: 0, // 总页数
  }

  async componentWillMount() {
    if (window.common.loginOut(this)) {
      const level = window.localStorage.getItem('level');
      const fullName = window.localStorage.getItem('fullName');
      this.getPayInfo();
      this.getRechargeList(this.state.currentPage);
      this.setState({level, fullName});
    } else {
      message.error('登录信息失效，请重新登录');
    }
  }

  // 改变条件
  handleChange = (type, value, obj) => {
    const params = {[type]: value};
    type === 'showDetail' ? params.detail = obj : null;
    this.setState(params);
  }

  // 跳转到支付申请页面
  toRechargeApplication = () => {
    this.props.history.push('/rechargeApplication', {recharge: this.state.payInfo[1].available_balance});
  }

  // 获取充值列表
  getRechargeList(currentPage) {
    const {
      firstStatus, secondStatus, createDate, rechargeType, invoiceType
    } = this.state;
    let startTime = null;
    let endTime = null;
    if (createDate) {
      startTime = utils.getDate(createDate[0]._d, 1);
      endTime = utils.getDate(createDate[1]._d, 1);
    }
    let params = {
      first_check_status: firstStatus, // 初审状态
      second_check_status: secondStatus, // 复审状态
      recharge_type: rechargeType, // 充值方式
      invoice_type: invoiceType, // 是否开票
      start_time: startTime,
      end_time: endTime,
      page_size: 10,
      current_page: currentPage,
    };
    params = utils.dealElement(params);
    window.api('eps.getrechargelist', params).then(res => {
      this.setState({recordList: res.recharge_List, total: res.total_result, currentPage});
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
    });
  }


  // 获取支付信息
  getPayInfo() {
    const params = {
      login_name: JSON.parse(window.localStorage.getItem('headParams')).login_name
    };
    window.api('Info.getaccountlist', params).then(res => {
      res.account.forEach(item => {
        item.available_balance = (Number(item.available_balance)).toFixed(2);
      });
      this.setState({payInfo: res.account});
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
    });
  }

  // 获取充值详情
  getDetail = (id) => {
    window.api('eps.recharge.getinfo', {recharge_id: id}).then(res => {
      this.setState({showDetail: true, rechargeDetail: res});
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
    });
  }

  // 变更页码
  changePage = async (page) => {
    await this.setState({currentPage: Number(page)});
    this.getRechargeList(page);
  }

  // 取消筛选条件
  clearConditions = async () => {
    await this.setState({
      firstStatus: null,
      secondStatus: null,
      createDate: null,
      rechargeType: null,
      invoiceType: null
    });
    this.getRechargeList(1);
  }

  render() {
    const {
      redirect, level, fullName, createDate, recordList, showDetail, rechargeDetail, payInfo, currentPage, total, firstStatus, secondStatus, rechargeType, invoiceType, payMod
    } = this.state;
    if (redirect) return (<Redirect to="/login" />);
    return (
      <div id="personalDetails">
        <Modal
          visible={showDetail}
          title="支付详情"
          footer={false}
          width="880px"
          onCancel={this.handleChange.bind(this, 'showDetail', false)}
        >
          <RechargeDetail detail={rechargeDetail} />
        </Modal>
        <header>
          <div className="info">
            <p>{fullName}</p>
            <Vip status={Number(level)} />
          </div>
          <div className="account">
            <h3>我的账户</h3>
            <div>
              <ul>
                {
                  payInfo.map((item, index) => (
                    <li key={index}>
                      <p>{item.available_balance}</p>
                      <p>{payMod[index]}</p>
                      {/* <p>{payMod[index]}<span hidden={index === 0} onClick={this.toRechargeApplication}>【充值】</span></p> */}
                    </li>
                  ))
                }
              </ul>
            </div>
          </div>
        </header>
        <section>
          <h3>充值记录</h3>
          <ul className="operation">
            <li>
              <p>初审状态:</p>
              <Select value={firstStatus} style={{width: 225}} onChange={this.handleChange.bind(this, 'firstStatus')}>
                <Option value={null}>全部</Option>
                <Option value="1">待审核</Option>
                <Option value="2">审核通过</Option>
                <Option value="3">审核不通过</Option>
              </Select>
              <p>创建日期:</p>
              <RangePicker format={dateFormat} onChange={this.handleChange.bind(this, 'createDate')} value={createDate} />
            </li>
            <li>
              <p>复审状态:</p>
              <Select value={secondStatus} style={{width: 225}} onChange={this.handleChange.bind(this, 'secondStatus')}>
                <Option value={null}>全部</Option>
                <Option value="1">待审核</Option>
                <Option value="2">审核通过</Option>
                <Option value="3">审核不通过</Option>
              </Select>
              <p>充值方式:</p>
              <Select value={rechargeType} style={{width: 225}} onChange={this.handleChange.bind(this, 'rechargeType')}>
                <Option value={null}>全部</Option>
                <Option value="2">线下转账</Option>
                <Option value="1">返佣账户充值</Option>
              </Select>
              <p>发票类型:</p>
              <Select value={invoiceType} style={{width: 225}} onChange={this.handleChange.bind(this, 'invoiceType')}>
                <Option value={null}>全部</Option>
                <Option value="0">不开发票</Option>
                <Option value="1">增值税普票-纸质</Option>
                <Option value="2">增值税普票-电子</Option>
                <Option value="3">增值税专票</Option>
              </Select>
            </li>
            <li>
              <Button type="primary" onClick={this.getRechargeList.bind(this, 1)}>查询</Button>
              <Button onClick={this.clearConditions}>重置</Button>
            </li>
          </ul>
          <ul className="list">
            <li>
              <p style={{width: '15%'}}>创建时间</p>
              <p style={{width: '15%'}}>代理商编号/代理商名称</p>
              <p style={{width: '10%'}}>充值金额</p>
              <p style={{width: '10%'}}>充值方式</p>
              <p style={{width: '10%'}}>是否开票</p>
              <p style={{width: '10%'}}>发票类型</p>
              <p style={{width: '10%'}}>初审状态</p>
              <p style={{width: '10%'}}>复审状态</p>
              <p style={{width: '10%'}}>操作</p>
            </li>
            { 
              recordList.length > 0 ? (
                recordList.map((item, index) => (
                  <li key={index}>
                    <p style={{width: '15%'}}>{item.gmt_created}</p>
                    <p style={{width: '15%'}}>{item.agent_no}/{item.agent_name}</p>
                    <p style={{width: '10%'}}>{item.recharge_amt}</p>
                    <p style={{width: '10%'}}>{item.recharge_type === '1' ? '返佣账户充值' : '线下转账'}</p>
                    <p style={{width: '10%'}}>{Number(item.invoice_type) ? '是' : '否'}</p>
                    <p style={{width: '10%'}}>{GetStatus({status: item.invoice_type, type: 'invoiceType'})}</p>
                    <p style={{width: '10%'}}>{GetStatus({status: item.first_check_status, type: 'status'})}</p>
                    <p style={{width: '10%'}}>{GetStatus({status: item.second_check_status, type: 'status'})}</p>
                    <p style={{width: '10%', color: '#009dd2', cursor: 'pointer'}} onClick={this.getDetail.bind(this, item.id)}>详情</p>
                  </li>
                ))
              ) : (
                <li>
                  <p style={{width: '100%'}}>暂无数据</p>
                </li>
              )
            }
          </ul>
          <Pagination
            className="pagination"
            style={{display: 'flex', justifyContent: 'flex-end'}}
            showQuickJumper
            showSizeChange
            current={currentPage}
            defaultCurrent={1}
            defaultPageSize={10}
            total={Number(total)}
            onChange={this.changePage}
          />
        </section>
      </div>
    );
  }
}

export default SearchDetail;



// WEBPACK FOOTER //
// ./src/containers/frontEnd/personalDetails/personalDetails.jsx